import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Icon from 'dpl/common/components/Icon';
import TransportationModal from 'dpl/breeder_search_results/components/TransportationModal';
import { TRANSPORT_TYPES } from 'dpl/breeder_search_results/utils/constants';

const { AIR, GROUND } = TRANSPORT_TYPES;

export default function PuppyCardTransport({
  deliveryMethods,
  breederFirstName,
  facilityLocation,
  puppyName,
  distance
}) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const transportTypes = Object.keys(deliveryMethods);

  const hasTransportation =
    transportTypes.includes(AIR) || transportTypes.includes(GROUND);

  function handleOpenClick(e) {
    e.preventDefault();
    e.stopPropagation();
    setIsModalOpen(true);
  }

  function handleCloseClick(e) {
    e?.stopPropagation?.();
    setIsModalOpen(false);
  }

  const mileOrMiles = distance === 1 ? 'mile' : 'miles';

  const milesAway = distance ? `${distance} ${mileOrMiles} away` : '';
  const isNearby = distance <= 200;

  function renderCopy() {
    return hasTransportation ? 'Drop off to you' : 'Meet breeder for pickup';
  }

  return (
    <div className="BreederSearchResultsTransport f2">
      <button
        type="button"
        className="fw-medium flex items-center gray pointer"
        tabIndex="0"
        onClick={handleOpenClick}
      >
        <span className="flex mr1">
          <Icon className="mr1" name="car-16" width="14px" height="14px" />
        </span>
        {isNearby && Boolean(milesAway) ? <p>{milesAway}</p> : renderCopy()}
      </button>
      {isModalOpen && (
        <TransportationModal
          onCloseClick={handleCloseClick}
          deliveryMethods={deliveryMethods}
          breederFirstName={breederFirstName}
          facilityLocation={facilityLocation}
          puppyName={puppyName}
        />
      )}
    </div>
  );
}

PuppyCardTransport.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  deliveryMethods: PropTypes.object.isRequired,
  breederFirstName: PropTypes.string,
  facilityLocation: PropTypes.string,
  puppyName: PropTypes.string,
  distance: PropTypes.number
};

PuppyCardTransport.defaultProps = {
  breederFirstName: null,
  facilityLocation: null,
  puppyName: null,
  distance: null
};
